<template>
	<div :class="{'page-nav-mobile-wrapper':true}" class="mobile-header-menu">
		<b-container class="page-nav-container">
			<b-nav small class="page-nav-mobile">
				<li class="nav-item no-border nav-item-back-to-list"><a @click="goBack()" class="nav-link" target="_self"><span><img src="/img/nav/icon-back.svg" alt="menu" class="">Back</span></a></li>

				<b-nav-item @click.prevent="toggleAdvancedSearch" class="nav-item-menu no-border side-page-filter" :class="filterActive ? 'side-filter-active' : ''">
					<span>
						<img v-if="!filterActive && advancedFilterCount == 0" src="@/assets/lc-header-filter.svg" />
						<img v-else src="/img/nav/icon-filter-dark-reverse.svg" />
						<span v-if="advancedFilterCount">{{advancedFilterCount}} </span>
						<span class="menu-text">Filters</span>
					</span>
				</b-nav-item>
				<b-nav-item @click="doNothing" class="nav-item-filler no-border">
					<span>
						<span class="menu-text">&nbsp;</span>
					</span>
				</b-nav-item>
				<b-nav-item @click="toggleMenu" class="nav-item-menu no-border">
					<span>
						<b-img src="/img/nav/icon-menu.svg" alt="menu" />
						<span class="menu-text">Menu</span>
					</span>
				</b-nav-item>
			</b-nav>
		</b-container>



		<div v-if="false" class="lane-closure-filters lane-closure-filters-mobile" :class="{'fixed-header-active': (showMessages || showUpdates || showAdvancedSearch)}">
			<div class="alerts" :class="{'expandedPanels':showMessages || showUpdates || showAdvancedSearch}">
				<a :href="backToListURL()" class="options options--goback">
					<b-img src="/img/nav/icon-back.svg" alt="menu" />
					<span>
						<span>Back</span>
					</span>
				</a>
				<div @click="toggleMenu" class="options">
					<b-img src="/img/lcr-quick-nav/menuicon.svg" alt="menu" />
					<span>
						<span class="pl-0">Menu</span>
					</span>
				</div>

			</div>
		</div>
			<transition name="slide-down" tag="div">
			<div v-if="showUpdates" :class="{'expandedUpdates': showUpdates}" class="notification-entry updates-wrapper row">
				<b-collapse :visible="showUpdates" id="updates-expandable">
					<div class="updates-wrapper-header" v-if="updateNotifications.length >= 1">
						<span class="updates-wrapper-header-title">Updates</span> <b-badge v-show="updateNotificationsCount > 0">{{updateNotificationsCount}}</b-badge>
						<router-link v-if="false" class="btn text-primary btn-sm btn-text float-right btn-notification-settings" to="/my-notifications"><span>Settings</span></router-link>
						<b-link class="btn text-primary btn-sm btn-text float-right btn-notification-settings" @click="clearAllClick('updates')"><span>Mark All Read</span></b-link>

					</div>
					<div class="updates-wrapper-body">
					<b-row v-for="(entry, i) in updateNotifications" :key="i">
						<b-col cols="1">
							<svg width="10" height="10">
								<circle cx="5" cy="5" r="5" :fill="getNotificationBubbleColor(entry)" />
							</svg>
						</b-col>
						<b-col @click="goToNotificationDest(entry)">
							<p>{{entry.messageTitle}}</p>
							<h6 v-html="entry.message"></h6>
							<p>{{moment(entry.notificationDate).fromNow()}}</p>
						</b-col>
					</b-row>
					<b-row v-if="updateNotifications.length < 1">
						<b-col>
							<p>No Unread Updates</p>
						</b-col>
					</b-row>
					<div @click="swipeUpHandler" class="close-panels">
						<img src="@/assets/lc-close.svg" />
					</div>
					</div>
				</b-collapse>
			</div>
			<b-row v-if="showMessages" :class="{'expandedMessages': showMessages}" class="notification-entry messages-wrapper">
				<b-collapse :visible="showMessages" id="messages-expandable">
					<div class="messages-wrapper-header" v-if="messageNotifications.length > 0">
					<span class="messages-wrapper-header-title">Messages</span><b-badge v-show="messageNotificationsCount > 0">{{messageNotificationsCount}}</b-badge>
					<router-link v-if="false" class="btn text-primary btn-sm btn-text float-right btn-notification-settings" to="/my-notifications"><span>Settings</span></router-link>
					<b-link class="btn text-primary btn-sm btn-text float-right btn-notification-settings" @click="clearAllClick('messages')"><span>Mark All Read</span></b-link>
					</div>
					<div class="messages-wrapper-body">
					<b-row v-for="(entry, i) in messageNotifications" :key="i">
						<b-col cols="1">
							<svg width="10" height="10">
								<circle cx="5" cy="5" r="5" :fill="getNotificationBubbleColor(entry)" />
							</svg>
						</b-col>
						<b-col @click="goToNotificationDest(entry)">
							<p class="m-0">{{entry.messageTitle}}</p>
							<strong v-html="entry.message"></strong>
							<p>{{moment(entry.notificationDate).fromNow()}}</p>
						</b-col>
					</b-row>
					<b-row v-if="messageNotifications.length < 1">
						<b-col>
							<p>No New Messages</p>
						</b-col>
					</b-row>
					<div @click="swipeUpHandler" class="close-panels">
						<img src="@/assets/lc-close.svg" />
					</div>
					</div>
				</b-collapse>
			</b-row>
			</transition>
			<div class="lane-closure-filters__title">{{title}}</div>
	</div>

</template>
<script>
import Vue from 'vue'
import LaneClosureRequest from './../models/LaneClosureRequest'

export default {
	name: 'LaneFilters',
	components: {
		// 'input-auto-complete': InputAutoComplete
	},
	props: {
		columns: Array,
		totals: Object,
		callOptionMethod: String,
		unreadMessagesCount: Number,
		unreadUpdatesCount: Number,
		title: String,
		storeArgs: String,
		storeModule: String,
		showBack:Boolean,
		url:String,
		backToList:Number,
	},
	data: () => ({
		advancedFilterCount: false,
		messageNotifications: [],
		updateNotifications: [],
		messageNotificationsCount: 0,
		updateNotificationsCount: 0,
		showAdvancedSearch: false,
		showMessages: false,
		showUpdates: false,
		filterActive: false,
		hasAdvanceFiltersState: false,
		LaneClosureRequest,
	}),
	created() {},
	mounted() {
		Vue.prototype.$bus.$off('menu:hasAdvanceFiltersState', this.hasAdvanceFiltersStateFn);
		Vue.prototype.$bus.$on('menu:hasAdvanceFiltersState', this.hasAdvanceFiltersStateFn);
		Vue.prototype.$bus.$off('menu:advanceFiltersCount', this.advanceFiltersCountFn);
		Vue.prototype.$bus.$on('menu:advanceFiltersCount', this.advanceFiltersCountFn);
		Vue.prototype.$bus.$off('menu:advanceFiltersExpandedState', this.advanceFiltersExpandedStateFn);
		Vue.prototype.$bus.$on('menu:advanceFiltersExpandedState', this.advanceFiltersExpandedStateFn);
		this.getUnreadNotifications();
	},
	watch: {
		'unreadMessagesCount': function() {
			let that = this;
			that.messageNotifications = that.$store.getters['notificationList/messages'];
			that.updateNotifications = that.$store.getters['notificationList/updates'];
			that.messageNotificationsCount = that.$store.getters['notificationList/unreadMessagesCount'];
			that.updateNotificationsCount = that.$store.getters['notificationList/unreadUpdatesCount'];
			Vue.prototype.$bus.$emit("notification:refresh");
		},
		'isLoggedIn': function() {
			if (this.isLoggedIn) {
				this.getUnreadNotifications();
			}
		}
	},
	computed: {
		isLoggedIn: function() {
			return this.$store.getters.isLoggedIn
		},
	},
	methods: {
		advanceFiltersExpandedStateFn(status) {
			this.filterActive = status;
		},
		advanceFiltersCountFn(count) {
			this.advancedFilterCount = count;
		},
		hasAdvanceFiltersStateFn(state) {
			this.hasAdvanceFiltersState = state;
		},
		showHeaderFilter() {
			let showingRoutes = [
				'UserList',
				'OrganizationList',
				'UserApprovalList',
				'OrganizationRequestList',
				'AuditLogList'
			];
			console.log(this.$router.currentRoute.name);
			if(showingRoutes.indexOf(this.$router.currentRoute.name) != -1) {
				return true;
			} else {
				return false;
			}
		},
		toggleAdvancedSearch() {
			this.filterActive = !this.filterActive;
			Vue.prototype.$bus.$emit('menu:toggleUserAdvanceFilter');
		},
		goBack() {
			// history.go(-1);
			this.$router.go(-1);
		},
		backToListURL() {

			if (this.url == null) {
				let lastPage = this.$routerStore.getters['getLastListPageOrViewRequest'];
				if (lastPage == null) {
					return "/lane-closure-request-list";
				} else {
					if (lastPage.name == this.$router.name	) {
						lastPage =  this.$routerStore.getters['getLastListPage'];
						if (lastPage == null) {
							return "/lane-closure-request-list";
						}
					} else {
						lastPage =  this.$routerStore.getters['getLastListPage'];
						if (lastPage == null) {
							return "/lane-closure-request-list";
						}
					}
				}
				return lastPage.path;
			} else {
				return this.url;
			}
		},
		clearAllClick(type) {
			if (type == "messages") {
				this.$store.dispatch('notificationList/dismissAllMessageNotification', type)
				.then(() => {
					this.messageNotifications = this.$store.getters['notificationList/messages'];
					this.updateNotifications = this.$store.getters['notificationList/updates'];
					this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
					this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
					Vue.prototype.$bus.$emit("notification:refresh");
				});
			} else {
				this.$store.dispatch('notificationList/dismissAllUpdateNotification', type)
				.then(() => {
					this.messageNotifications = this.$store.getters['notificationList/messages'];
					this.updateNotifications = this.$store.getters['notificationList/updates'];
					this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
					this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
					Vue.prototype.$bus.$emit("notification:refresh");
				});
			}
		},
		getMessageTitle() {
			if (this.unreadMessagesCount == 1) {
				return "1 Message";
			} else {
				return this.unreadMessagesCount + " Messages";
			}
		},
		getUpdateTitle() {
			if (this.unreadUpdatesCount == 1) {
				return "1 Update";
			} else {
				return this.unreadUpdatesCount + " Updates";
			}
		},
		swipeUpHandler() {
			this.showAdvancedSearch = false;
			this.showMessages = false;
			this.showUpdates = false;
		},
		getNotificationBubbleColor(entry) {
			if (entry.readDate || entry.isRead == 1) {
				return '#eeeeee';
			} else {
				return '#293c7c';
			}
		},
		goToNotificationDest(notification) {
			if (notification.lcrId) {
				if (notification.notificationTypeId == 'new-contravention') {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view-contravention/${notification.entityId}`);
				} else if ( notification.notificationTypeId == 'contravention-new-message') {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view-contravention/${notification.contraventionId}`);
				} else {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view`);
				}
			}

			this.showNotifications = false;
		},
		showNotification(entry) {
			if (['lcr-new-message', 'lcr-change-request', 'contravention-new-message'].includes(entry.notificationTypeId)) {
				this.messageNotifications.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) this.messageNotificationsCount++;
			} else {
				this.updateNotifications.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) this.updateNotificationsCount++;
			}
		},
		getUnreadNotifications() {
			let that = this;
			this.$store.dispatch('notificationList/load').then(() => {
				that.messageNotifications = that.$store.getters['notificationList/messages'];
				that.updateNotifications = that.$store.getters['notificationList/updates'];
				that.messageNotificationsCount = that.$store.getters['notificationList/unreadMessagesCount'];
				that.updateNotificationsCount = that.$store.getters['notificationList/unreadUpdatesCount'];
				Vue.prototype.$bus.$emit("notification:refresh");
			});
		},

		doNothing() {
			// yup, not doing anything.
		},
		toggleMessages() {
			this.showAdvancedSearch = false;
			this.showUpdates = false;
			this.showMessages = !this.showMessages;
		},
		toggleUpdates() {
			this.showAdvancedSearch = false;
			this.showMessages = false;
			this.showUpdates = !this.showUpdates;
		},

		toggleMenu() {
			Vue.prototype.$bus.$emit('menu:toggle', null);
		},

	}
}
</script>